import Alpine, { Alpine as AlpineType } from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import mask from '@alpinejs/mask';

import { checkbox } from './data/checkbox';
import { footerItem } from './data/footerItem';
import { input } from './data/input';
import { js3q } from './data/js3q';
import { navigation } from './data/navigation';
import { navigationFlyoutItem } from './data/navigationFlyoutItem';
import { password } from './data/password';
import { passwordRepeat } from './data/passwordRepeat';
import { select } from './data/select';
import { testimonialsSwiper } from './data/testimonialsSwiper';
import { waitingRoom } from './data/waitingRoom';
import { courseDetailGuest } from './data/courseDetailGuest';

declare global {
  interface Window {
    Alpine?: AlpineType;
  }
}

export function initAlpinejs() {
  /* --------------------------------- PLUGINS -------------------------------- */

  Alpine.plugin(mask);
  Alpine.plugin(collapse);
  Alpine.plugin(focus);

  /* ---------------------------------- DATA ---------------------------------- */

  Alpine.data('waitingRoom', waitingRoom);
  Alpine.data('checkbox', checkbox);
  Alpine.data('footerItem', footerItem);
  Alpine.data('input', input);
  Alpine.data('js3q', js3q);
  Alpine.data('navigation', navigation);
  Alpine.data('navigationFlyoutItem', navigationFlyoutItem);
  Alpine.data('password', password);
  Alpine.data('passwordRepeat', passwordRepeat);
  Alpine.data('select', select);
  Alpine.data('testimonialsSwiper', testimonialsSwiper);
  Alpine.data('courseDetailGuest', courseDetailGuest);

  /* ---------------------------------- INIT ---------------------------------- */

  window.Alpine = Alpine;
  Alpine.start();
}
